import store from "@/store";

const $getTab = (name) => {
	// console.log(name);
	let data = store.state.mainTabs;
	// console.log(data);
      for (let i = 0; i < data.length; i++) {
      if (data[i].name == name) return data[i];
      }
      return null; //没有找到
}

// 格式化日期
const $fermitDate = function(time) {
	var now = new Date(time);
	var year = now.getFullYear();
	var mon = now.getMonth() + 1;
	var date = now.getDate();
	if (mon < 10) {
		mon = '0' + mon;
	};
	if (date < 10) {
		date = '0' + date;
	}
	var postDate = year + '-' + mon + '-' + date;
	return postDate;
}

export default {
  install: (app) => {
        app.config.globalProperties["$getTab"] = $getTab;
    	app.config.globalProperties["$fermitDate"] = $fermitDate;
  },
};